import { useIntl } from 'react-intl';

import { useLoginStates } from '@/hooks';

export const useDialogCopies = () => {
  const intl = useIntl();
  const { isLoggedIn } = useLoginStates();

  return isLoggedIn
    ? {
        headline: intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_CANCEL_DIALOG_TITLE' }),
        text: intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_CANCEL_DIALOG_CONTENT' }),
        confirmLabel: intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_CANCEL_DIALOG_CONFIRM_BUTTON' }),
        cancelLabel: intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_CANCEL_DIALOG_CANCEL_BUTTON' }),
      }
    : {
        headline: intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_LO_CANCEL_DIALOG_TITLE' }),
        text: intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_LO_CANCEL_DIALOG_CONTENT' }),
        confirmLabel: intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_LO_CANCEL_DIALOG_CONFIRM_BUTTON' }),
        cancelLabel: intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_LO_CANCEL_DIALOG_CANCEL_BUTTON' }),
      };
};
